import { WithClassName } from 'src/utils/UtilityTypes';
import { SpotMarketConfig } from '@drift-labs/sdk';
import { cj } from 'src/utils/classNames';
import { UIMarket } from '@drift/common';
import useCurrentWalletCollateralBalance from 'src/hooks/useCurrentWalletCollateralBalance';

export const CardAssetBalance = ({
	marketIndex,
	className,
}: { marketIndex: number } & WithClassName) => {
	const spotMarketConfig = UIMarket.createSpotMarket(marketIndex);
	const [assetBalance] = useCurrentWalletCollateralBalance(
		spotMarketConfig.market as SpotMarketConfig
	);
	return (
		<div
			className={cj(
				'flex flex-row items-center gap-x-xs typo-b4 text-text-default',
				className
			)}
		>
			<span className="text-text-secondary">Wallet Balance</span>
			<span className="text-text-default">
				{assetBalance.toMillified()}{' '}
				{spotMarketConfig.uiSymbols.baseAssetDisplaySymbol}
			</span>
		</div>
	);
};
